import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { string } from 'prop-types'
import { useZionFormContext, useAtSize, Avatar } from '@fs/zion-ui'
import { determineGender } from '../shared/helpers/gedcom_X'

// Thanks Sonukr! https://github.com/jaredpalmer/formik/issues/45#issuecomment-482977936
export default function AncestorAvatar({ fieldName, fieldValue, genderType }) {
  const [t] = useTranslation()
  const atSize = useAtSize()
  const [imageError, setImageError] = useState(false)
  const { makeFormComponent } = useZionFormContext()

  const ancestorPlaceholderContainer = css`
    justify-content: center;
    align-content: top;
    padding: 0 2em;
    position: absolute;
    top: -60px;
    display: flex;
    align-items: flex-start;
    left: 0;
    right: 0;
  `

  const portraitCss = css`
    border-radius: 50%;
    box-shadow: inset 0 2px 4px 0 hsla(0, 0%, 51.8%, 0.5);
    margin: 0 auto;
  `

  return makeFormComponent(
    <div css={ancestorPlaceholderContainer}>
      {fieldValue && !imageError ? (
        <img
          name={fieldName}
          src={fieldValue}
          alt={t('atf.ancestor-editor.ancestor-portrait', "Your ancestor's photo.")}
          onError={() => setImageError(true)}
          width="88"
          height="88"
          css={portraitCss}
        />
      ) : (
        <Avatar size={atSize({ default: 'lg' })} sex={determineGender(genderType)} />
      )}
    </div>
  )
}

AncestorAvatar.propTypes = {
  fieldName: string,
  fieldValue: string,
  genderType: string,
}
